import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import qs from "qs";

import { setUserToken } from "store/auth";
import { routes } from "constants/routes";
import { axios } from "services/middleware";

const useOverrideTokenFromURL = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    const token = queryParams.as as string | undefined;
    if (token) {
      dispatch(setUserToken(token));
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      navigate(routes.HOME, { replace: true });
    }
  }, [location.search, dispatch, navigate, location.pathname]);
};

export default useOverrideTokenFromURL;
